var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.52676 2.12302C8.7518 -0.328116 12.2482 -0.328117 13.4732 2.12302L20.1448 15.4718C21.2499 17.683 19.6427 20.2847 17.1715 20.2847H3.82847C1.35733 20.2847 -0.249895 17.683 0.855233 15.4718L7.52676 2.12302Z",
    fill: "#FFEB8C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7119 6.69479C10.6696 6.46154 10.4655 6.28467 10.22 6.28467C9.94386 6.28467 9.72 6.50853 9.72 6.78467V14.7847L9.72806 14.8745C9.77039 15.1078 9.97454 15.2847 10.22 15.2847C10.4961 15.2847 10.72 15.0608 10.72 14.7847V6.78467L10.7119 6.69479ZM10.25 17.7077C10.6642 17.7077 11 17.372 11 16.9577C11 16.5435 10.6642 16.2077 10.25 16.2077C9.83579 16.2077 9.5 16.5435 9.5 16.9577C9.5 17.372 9.83579 17.7077 10.25 17.7077Z",
    fill: "#5A3C1E"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.c49932946e2a9332f761e3de99adfe24.svg";
export { ForwardRef as ReactComponent };